/**
 * Maps a Streamr region code (number) to its location data.
 * Generated from airportCodeToRegion.ts
 * Format: { regionCode: { lat: number, long: number, code: string } }
 */
export const regionToLocationMap = {
    100: { lat: 40.639447, long: -73.779317, code: 'JFK' },
    200: { lat: 40.777199, long: -73.872597, code: 'LGA' },
    300: { lat: 40.692501, long: -74.168701, code: 'EWR' },
    400: { lat: 42.94049835, long: -78.73220062, code: 'BUF' },
    500: { lat: 47.529999, long: -122.302002, code: 'BFI' },
    600: { lat: 47.449162, long: -122.311134, code: 'SEA' },
    700: { lat: 45.58869934, long: -122.5979996, code: 'PDX' },
    800: { lat: 45.540401, long: -122.949997, code: 'HIO' },
    900: { lat: 38.69540023803711, long: -121.59100341796875, code: 'SMF' },
    1000: { lat: 37.61899948120117, long: -122.375, code: 'SFO' },
    1100: { lat: 37.461101532, long: -122.114997864, code: 'PAO' },
    1200: { lat: 37.362452, long: -121.929188, code: 'SJC' },
    1300: { lat: 36.9356994629, long: -121.790000916, code: 'WVI' },
    1400: { lat: 34.197703, long: -118.356378, code: 'BUR' },
    1500: { lat: 33.942501, long: -118.407997, code: 'LAX' },
    1600: { lat: 32.7336006165, long: -117.190002441, code: 'SAN' },
    1700: { lat: 36.083361, long: -115.151817, code: 'LAS' },
    1800: { lat: 33.435302, long: -112.005905, code: 'PHX' },
    1900: { lat: 35.040199, long: -106.609001, code: 'ABQ' },
    2000: { lat: 39.861698150635, long: -104.672996521, code: 'DEN' },
    2100: { lat: 40.785749, long: -111.979746, code: 'SLC' },
    2200: { lat: 44.93479, long: -93.060036, code: 'STP' },
    2300: { lat: 44.882, long: -93.221802, code: 'MSP' },
    2400: { lat: 43.585463, long: -96.741152, code: 'FSD' },
    2500: { lat: 41.3032, long: -95.894096, code: 'OMA' },
    2600: { lat: 39.2976, long: -94.713898, code: 'MCI' },
    2700: { lat: 35.393101, long: -97.6007, code: 'OKC' },
    2800: { lat: 32.9686012268, long: -96.8364028931, code: 'ADS' },
    2900: { lat: 32.896801, long: -97.038002, code: 'DFW' },
    3000: { lat: 29.984399795532227, long: -95.34140014648438, code: 'IAH' },
    3100: { lat: 30.197535, long: -97.662015, code: 'AUS' },
    3200: { lat: 29.533701, long: -98.469803, code: 'SAT' },
    3300: { lat: 26.176141, long: -98.237965, code: 'MFE' },
    3400: { lat: 21.32062, long: -157.924228, code: 'HNL' },
    3500: { lat: 61.1744, long: -149.996002, code: 'ANC' },
    3600: { lat: 42.3643, long: -71.005203, code: 'BOS' },
    3700: { lat: 44.8074, long: -68.828102, code: 'BGR' },
    3800: { lat: 43.6772, long: -79.6306, code: 'YTO' },
    3900: { lat: 43.6772, long: -79.6306, code: 'YYZ' },
    4000: { lat: 45.322498, long: -75.669197, code: 'YOW' },
    4100: { lat: 45.4706, long: -73.740799, code: 'YUL' },
    4200: { lat: 44.8807983398, long: -63.5085983276, code: 'YHZ' },
    4300: { lat: 49.193901062, long: -123.183998108, code: 'YVR' },
    4400: { lat: 51.113899231, long: -114.019996643, code: 'YYC' },
    4500: { lat: 52.170799255371094, long: -106.69999694824219, code: 'YXE' },
    4600: { lat: 49.909999847399995, long: -97.2398986816, code: 'YWG' },
    4700: { lat: 63.985001, long: -22.6056, code: 'KEF' },
    4800: { lat: 53.428713, long: -6.262121, code: 'DUB' },
    4900: { lat: 51.841301, long: -8.49111, code: 'ORK' },
    5000: { lat: 53.349375, long: -2.279521, code: 'MAN' },
    5100: { lat: 51.4706, long: -0.461941, code: 'LHR' },
    5200: { lat: 51.4706, long: -0.461941, code: 'LON' },
    5300: { lat: 51.505299, long: 0.055278, code: 'LCY' },
    5400: { lat: 55.950145, long: -3.372288, code: 'EDI' },
    5500: { lat: 50.901402, long: 4.48444, code: 'BRU' },
    5600: { lat: 52.308601, long: 4.76389, code: 'AMS' },
    5700: { lat: 51.289501, long: 6.76678, code: 'DUS' },
    5800: { lat: 50.036521, long: 8.561268, code: 'FRA' },
    5900: { lat: 50.049800872802734, long: 8.325400352478027, code: 'WIE' },
    6000: { lat: 48.689899, long: 9.22196, code: 'STR' },
    6100: { lat: 48.353802, long: 11.7861, code: 'MUC' },
    6200: { lat: 52.362247, long: 13.500672, code: 'TXL' },
    6300: { lat: 53.630402, long: 9.98823, code: 'HAM' },
    6400: { lat: 49.6233333, long: 6.2044444, code: 'LUX' },
    6500: { lat: 49.012798, long: 2.55, code: 'DLP' },
    6600: { lat: 49.012798, long: 2.55, code: 'CDG' },
    6700: { lat: 49.012798, long: 2.55, code: 'PAR' },
    6800: { lat: 44.8283, long: -0.715556, code: 'BOD' },
    6900: { lat: 43.438088, long: 5.2125, code: 'MRS' },
    7000: { lat: 45.725556, long: 5.081111, code: 'LYS' },
    7100: { lat: 46.238098, long: 6.10895, code: 'GVA' },
    7200: { lat: 47.458056, long: 8.548056, code: 'ZRH' },
    7300: { lat: 45.6306, long: 8.72811, code: 'MXP' },
    7400: { lat: 45.445099, long: 9.27674, code: 'LIN' },
    7500: { lat: 41.804532, long: 12.251998, code: 'FCO' },
    7600: { lat: 38.175999, long: 13.091, code: 'PMO' },
    7700: { lat: 50.103514, long: 14.256992, code: 'PRG' },
    7800: { lat: 55.617900848389, long: 12.656000137329, code: 'CPH' },
    7900: { lat: 60.193901, long: 11.1004, code: 'OSL' },
    8000: { lat: 59.651901245117, long: 17.918600082397, code: 'ARN' },
    8100: { lat: 59.354400634765625, long: 17.941699981689453, code: 'BMA' },
    8200: { lat: 57.662799835205, long: 12.279800415039, code: 'GOT' },
    8300: { lat: 56.923599, long: 23.9711, code: 'RIX' },
    8400: { lat: 59.41329956049999, long: 24.832799911499997, code: 'TLL' },
    8500: { lat: 60.3172, long: 24.963301, code: 'HEL' },
    8600: { lat: 59.80030059814453, long: 30.262500762939453, code: 'LED' },
    8700: { lat: 56.82469940185547, long: 35.7577018737793, code: 'KLD' },
    8800: { lat: 55.40879821777344, long: 37.90629959106445, code: 'DME' },
    8900: { lat: 56.743099212646, long: 60.802700042725, code: 'SVX' },
    9000: { lat: 56.173077, long: 92.492437, code: 'KJA' },
    9100: { lat: 48.528338, long: 135.188588, code: 'KHV' },
    9200: { lat: 53.888071, long: 28.039964, code: 'MSQ' },
    9300: { lat: 54.634102, long: 25.285801, code: 'VNO' },
    9400: { lat: 52.1656990051, long: 20.967100143399996, code: 'WAW' },
    9500: { lat: 50.345001, long: 30.894699, code: 'KBP' },
    9600: { lat: 46.9277, long: 28.931, code: 'KIV' },
    9700: { lat: 44.572127, long: 26.103396, code: 'OTP' },
    9800: { lat: 41.261297, long: 28.741951, code: 'IST' },
    9900: { lat: 38.2924, long: 27.157, code: 'ADB' },
    10000: { lat: 37.936401, long: 23.9445, code: 'ATH' },
    10100: { lat: 40.51928, long: 22.970009, code: 'SKG' },
    10200: { lat: 42.696357, long: 23.417671, code: 'SOF' },
    10300: { lat: 41.4147, long: 19.7206, code: 'TIA' },
    10400: { lat: 44.818401, long: 20.309099, code: 'BEG' },
    10500: { lat: 47.43018, long: 19.262393, code: 'BUD' },
    10600: { lat: 48.1702, long: 17.2127, code: 'BTS' },
    10700: { lat: 48.110298, long: 16.5697, code: 'VIE' },
    10800: { lat: 45.742901, long: 16.0688, code: 'ZAG' },
    10900: { lat: 36.851002, long: 10.2272, code: 'TUN' },
    11000: { lat: 36.826781, long: 7.81334, code: 'AAE' },
    11100: { lat: 36.693886, long: 3.214531, code: 'ALG' },
    11200: { lat: 35.623901, long: -0.621183, code: 'ORN' },
    11300: { lat: 40.471926, long: -3.56264, code: 'MAD' },
    11400: { lat: 41.2971, long: 2.07846, code: 'BCN' },
    11500: { lat: 38.7813, long: -9.13592, code: 'LIS' },
    11600: { lat: 33.3675, long: -7.58997, code: 'CMN' },
    11700: { lat: 14.7397, long: -17.4902, code: 'DKR' },
    11800: { lat: 12.3532, long: -1.51242, code: 'OUA' },
    11900: { lat: 5.605189800262451, long: -0.16678600013256073, code: 'ACC' },
    12000: { lat: 6.5773701667785645, long: 3.321160078048706, code: 'LOS' },
    12100: { lat: -4.38575, long: 15.4446, code: 'FIH' },
    12200: { lat: -8.85837, long: 13.2312, code: 'LAD' },
    12300: { lat: -33.9648017883, long: 18.6016998291, code: 'CPT' },
    12400: { lat: -29.6144444444, long: 31.1197222222, code: 'DUR' },
    12500: { lat: -26.1392, long: 28.246, code: 'JNB' },
    12600: { lat: -25.920799, long: 32.572601, code: 'MPM' },
    12700: { lat: -24.555201, long: 25.9182, code: 'GBE' },
    12800: { lat: -17.931801, long: 31.0928, code: 'HRE' },
    12900: { lat: -18.7969, long: 47.478802, code: 'TNR' },
    13000: { lat: -20.890087, long: 55.518894, code: 'RUN' },
    13100: { lat: -20.430201, long: 57.683601, code: 'MRU' },
    13200: { lat: -6.87811, long: 39.202599, code: 'DAR' },
    13300: { lat: -4.03483, long: 39.5942, code: 'MBA' },
    13400: { lat: -1.31923997402, long: 36.9277992249, code: 'NBO' },
    13500: { lat: -1.96863, long: 30.1395, code: 'KGL' },
    13600: { lat: 11.5473, long: 43.1595, code: 'JIB' },
    13700: { lat: 30.111534, long: 31.396694, code: 'CAI' },
    13800: { lat: 32.011398, long: 34.8867, code: 'TLV' },
    13900: { lat: 32.80939865112305, long: 35.04309844970703, code: 'HFA' },
    14000: { lat: 31.91123, long: 35.20756, code: 'ZDM' },
    14100: { lat: 31.7226009369, long: 35.9931983948, code: 'AMM' },
    14200: { lat: 33.820899963378906, long: 35.488399505615234, code: 'BEY' },
    14300: { lat: 34.875099, long: 33.624901, code: 'LCA' },
    14400: { lat: 40.1473007202, long: 44.3959007263, code: 'EVN' },
    14500: { lat: 41.669201, long: 44.9547, code: 'TBS' },
    14600: { lat: 40.467498779296875, long: 50.04669952392578, code: 'GYD' },
    14700: { lat: 38.757919, long: 48.807042, code: 'LLK' },
    14800: { lat: 36.23759841918945, long: 43.963199615478516, code: 'EBL' },
    14900: { lat: 35.5617485046, long: 45.316738128699996, code: 'ISU' },
    15000: { lat: 33.262501, long: 44.2346, code: 'BGW' },
    15100: { lat: 31.989853, long: 44.404317, code: 'NJF' },
    15200: { lat: 30.935801, long: 46.090099, code: 'XNH' },
    15300: { lat: 30.549101, long: 47.662102, code: 'BSR' },
    15400: { lat: 29.226601, long: 47.968899, code: 'KWI' },
    15500: { lat: 24.9576, long: 46.698799, code: 'RUH' },
    15600: { lat: 26.471200942993164, long: 49.79790115356445, code: 'DMM' },
    15700: { lat: 21.6796, long: 39.156502, code: 'JED' },
    15800: { lat: 26.267295, long: 50.63764, code: 'BAH' },
    15900: { lat: 25.273056, long: 51.608056, code: 'DOH' },
    16000: { lat: 25.2527999878, long: 55.3643989563, code: 'DXB' },
    16100: { lat: 25.1122, long: 56.324001, code: 'FJR' },
    16200: { lat: 23.593299865722656, long: 58.284400939941406, code: 'MCT' },
    16300: { lat: 4.191830158233643, long: 73.52909851074219, code: 'MLE' },
    16400: { lat: 7.180759906768799, long: 79.88410186767578, code: 'CMB' },
    16500: { lat: 12.990005, long: 80.169296, code: 'MAA' },
    16600: { lat: 13.1979, long: 77.706299, code: 'BLR' },
    16700: { lat: 17.231318, long: 78.429855, code: 'HYD' },
    16800: { lat: 21.092199, long: 79.047203, code: 'NAG' },
    16900: { lat: 20.244400024399997, long: 85.8178024292, code: 'BBI' },
    17000: { lat: 22.654699325561523, long: 88.44670104980469, code: 'CCU' },
    17100: { lat: 23.0772, long: 72.634697, code: 'AMD' },
    17200: { lat: 19.0886993408, long: 72.8678970337, code: 'BOM' },
    17300: { lat: 18.5821, long: 73.919701, code: 'PNQ' },
    17400: { lat: 11.918614, long: 75.547211, code: 'CNN' },
    17500: { lat: 10.152, long: 76.401901, code: 'COK' },
    17600: { lat: 25.591299, long: 85.087997, code: 'PAT' },
    17700: { lat: 26.404301, long: 80.410103, code: 'KNU' },
    17800: { lat: 28.55563, long: 77.09519, code: 'DEL' },
    17900: { lat: 30.6735, long: 76.788498, code: 'IXC' },
    18000: { lat: 23.1838, long: 89.160797, code: 'JSR' },
    18100: { lat: 22.249599, long: 91.813301, code: 'CGP' },
    18200: { lat: 23.843347, long: 90.397783, code: 'DAC' },
    18300: { lat: 27.4032, long: 89.424599, code: 'PBH' },
    18400: { lat: 27.6966, long: 85.3591, code: 'KTM' },
    18500: { lat: 31.521601, long: 74.403603, code: 'LHE' },
    18600: { lat: 33.549, long: 72.82566, code: 'ISB' },
    18700: { lat: 24.9065, long: 67.160797, code: 'KHI' },
    18800: { lat: 41.257900238, long: 69.2811965942, code: 'TAS' },
    18900: { lat: 43.354267, long: 77.042828, code: 'ALA' },
    19000: { lat: 47.843102, long: 106.766998, code: 'ULN' },
    19100: { lat: 37.46910095214844, long: 126.45099639892578, code: 'ICN' },
    19200: { lat: 35.764702, long: 140.386002, code: 'TYO' },
    19300: { lat: 35.764702, long: 140.386002, code: 'NRT' },
    19400: { lat: 35.552299, long: 139.779999, code: 'HND' },
    19500: { lat: 34.785499572753906, long: 135.43800354003906, code: 'ITM' },
    19600: { lat: 34.427299, long: 135.244003, code: 'KIX' },
    19700: { lat: 33.585899353027344, long: 130.4510040283203, code: 'FUK' },
    19800: { lat: 26.195801, long: 127.646004, code: 'OKA' },
    19900: { lat: 13.4834, long: 144.796005, code: 'GUM' },
    20000: { lat: 8.612203, long: 124.456496, code: 'CGY' },
    20100: { lat: 10.309261, long: 123.97974, code: 'CEB' },
    20200: { lat: 14.5086, long: 121.019997, code: 'MNL' },
    20300: { lat: 4.9442, long: 114.928001, code: 'BWN' },
    20400: { lat: 10.8188, long: 106.652, code: 'SGN' },
    20500: { lat: 21.221201, long: 105.806999, code: 'HAN' },
    20600: { lat: 11.5466, long: 104.844002, code: 'PNH' },
    20700: { lat: 17.988300323500003, long: 102.56300354, code: 'VTE' },
    20800: { lat: 22.149599, long: 113.592003, code: 'MFM' },
    20900: { lat: 22.308901, long: 113.915001, code: 'HKG' },
    21000: { lat: 22.577101, long: 120.349998, code: 'KHH' },
    21100: { lat: 25.0777, long: 121.233002, code: 'TPE' },
    21200: { lat: 25.934669, long: 119.66318, code: 'FOC' },
    21300: { lat: 28.562201, long: 121.429001, code: 'HYN' },
    21400: { lat: 30.23609, long: 120.428865, code: 'HGH' },
    21500: { lat: 31.198104, long: 121.33426, code: 'SHA' },
    21600: { lat: 31.919701, long: 119.778999, code: 'CZX' },
    21700: { lat: 31.3906, long: 118.408997, code: 'WHU' },
    21800: { lat: 28.864815, long: 115.90271, code: 'KHN' },
    21900: { lat: 28.9189, long: 111.639999, code: 'CGD' },
    22000: { lat: 26.541466, long: 106.803331, code: 'KWE' },
    22100: { lat: 25.110313, long: 102.936743, code: 'KMG' },
    22200: { lat: 36.515202, long: 103.620003, code: 'LHW' },
    22300: { lat: 37.573125, long: 105.154454, code: 'ZHY' },
    22400: { lat: 38.280701, long: 114.696999, code: 'SJW' },
    22500: { lat: 39.509945, long: 116.41092, code: 'PKX' },
    22600: { lat: 40.080101013183594, long: 116.58499908447266, code: 'BJS' },
    22700: { lat: 39.124401092499994, long: 117.346000671, code: 'TSN' },
    22800: { lat: 36.857201, long: 117.216003, code: 'TNA' },
    22900: { lat: 36.361953, long: 120.088171, code: 'TAO' },
    23000: { lat: 19.9349, long: 110.459, code: 'HAK' },
    23100: { lat: 23.0833, long: 113.07, code: 'FUO' },
    23200: { lat: 23.392401, long: 113.299004, code: 'ZGN' },
    23300: { lat: 23.392401, long: 113.299004, code: 'CAN' },
    23400: { lat: 22.639299, long: 113.810997, code: 'SZX' },
    23500: { lat: 21.702199935913086, long: 95.97789764404297, code: 'MDL' },
    23600: { lat: 16.907300949099998, long: 96.1332015991, code: 'RGN' },
    23700: { lat: 18.766799926799997, long: 98.962600708, code: 'CNX' },
    23800: { lat: 13.681099891662598, long: 100.74700164794922, code: 'BKK' },
    23900: { lat: 9.13259983063, long: 99.135597229, code: 'URT' },
    24000: { lat: 2.74558, long: 101.709999, code: 'KUL' },
    24100: { lat: 1.64131, long: 103.669998, code: 'JHB' },
    24200: { lat: 1.36042, long: 103.910004, code: 'QPG' },
    24300: { lat: 1.35019, long: 103.994003, code: 'SIN' },
    24400: { lat: -6.1255698204, long: 106.65599823, code: 'CGK' },
    24500: { lat: -7.78818, long: 110.431999, code: 'JOG' },
    24600: { lat: -8.74817, long: 115.167, code: 'DPS' },
    24700: { lat: -4.8557, long: 139.482006, code: 'DEX' },
    24800: { lat: -31.94029998779297, long: 115.96700286865234, code: 'PER' },
    24900: { lat: -34.947512, long: 138.533393, code: 'ADL' },
    25000: { lat: -37.673302, long: 144.843002, code: 'MEL' },
    25100: { lat: -42.836101532, long: 147.509994507, code: 'HBA' },
    25200: { lat: -35.3069, long: 149.195007, code: 'CBR' },
    25300: { lat: -33.94609832763672, long: 151.177001953125, code: 'SYD' },
    25400: { lat: -27.384199142456055, long: 153.11700439453125, code: 'BNE' },
    25500: { lat: -43.48939895629883, long: 172.53199768066406, code: 'CHC' },
    25600: { lat: -41.3272018433, long: 174.804992676, code: 'WLG' },
    25700: { lat: -37.01199, long: 174.786331, code: 'AKL' },
    25800: { lat: -22.014601, long: 166.212997, code: 'NOU' },
    25900: { lat: -18.04330062866211, long: 178.5590057373047, code: 'SUV' },
    26000: { lat: -17.553699, long: -149.606995, code: 'PPT' },
    26100: { lat: 20.52504, long: -103.301557, code: 'GDL' },
    26200: { lat: 20.6173, long: -100.185997, code: 'QRO' },
    26300: { lat: 19.435433, long: -99.082432, code: 'MEX' },
    26400: { lat: 14.5833, long: -90.527496, code: 'GUA' },
    26500: { lat: 14.0609, long: -87.217201, code: 'TGU' },
    26600: { lat: 9.99386, long: -84.208801, code: 'SJO' },
    26700: { lat: 9.0713596344, long: -79.3834991455, code: 'PTY' },
    26800: { lat: 6.16454, long: -75.4231, code: 'MDE' },
    26900: { lat: 4.70159, long: -74.1469, code: 'BOG' },
    27000: { lat: -0.125399, long: -78.354306, code: 'UIO' },
    27100: { lat: -2.15742, long: -79.883598, code: 'GYE' },
    27200: { lat: -12.0219, long: -77.114305, code: 'LIM' },
    27300: { lat: -18.348499, long: -70.338699, code: 'ARI' },
    27400: { lat: -33.3930016, long: -70.7857971, code: 'SCL' },
    27500: { lat: -31.323601, long: -64.208, code: 'COR' },
    27600: { lat: -38.949001, long: -68.155701, code: 'NQN' },
    27700: { lat: -34.8222, long: -58.5358, code: 'EZE' },
    27800: { lat: -25.240156, long: -57.519227, code: 'ASU' },
    27900: { lat: -15.6529, long: -56.116699, code: 'CGB' },
    28000: { lat: -16.632, long: -49.220699, code: 'GYN' },
    28100: { lat: -15.869167, long: -47.920834, code: 'BSB' },
    28200: { lat: -18.883579, long: -48.225936, code: 'UDI' },
    28300: { lat: -20.817113, long: -49.406963, code: 'SJP' },
    28400: { lat: -21.134314, long: -47.774053, code: 'RAO' },
    28500: { lat: -23.007404, long: -47.134502, code: 'VCP' },
    28600: { lat: -23.478001, long: -47.490002, code: 'SOD' },
    28700: { lat: -23.431944, long: -46.467778, code: 'GRU' },
    28800: { lat: -23.431944, long: -46.467778, code: 'QWJ' },
    28900: { lat: -23.2292, long: -45.8615, code: 'SJK' },
    29000: { lat: -22.809999, long: -43.250557, code: 'GIG' },
    29100: { lat: -19.63571, long: -43.966928, code: 'CNF' },
    29200: { lat: -21.698299, long: -41.301701, code: 'CAW' },
    29300: { lat: -20.258, long: -40.285, code: 'VIX' },
    29400: { lat: -12.908611, long: -38.322498, code: 'SSA' },
    29500: { lat: -8.125984, long: -34.923316, code: 'REC' },
    29600: { lat: -7.21932, long: -39.269096, code: 'JDO' },
    29700: { lat: -3.775833, long: -38.532222, code: 'FOR' },
    29800: { lat: -1.379279, long: -48.476207, code: 'BEL' },
    29900: { lat: -3.03861, long: -60.049702, code: 'MAO' },
    30000: { lat: -29.994712, long: -51.166592, code: 'POA' },
    30100: { lat: -27.670279, long: -48.552502, code: 'FLN' },
    30200: { lat: -26.879431, long: -48.650979, code: 'ITJ' },
    30300: { lat: -26.879431, long: -48.650979, code: 'NVT' },
    30400: { lat: -26.831661, long: -49.093569, code: 'BNU' },
    30500: { lat: -26.224501, long: -48.797401, code: 'JOI' },
    30600: { lat: -25.5285, long: -49.1758, code: 'CWB' },
    30700: { lat: -26.787423, long: -50.939942, code: 'CFC' },
    30800: { lat: -27.134199, long: -52.656601, code: 'XAP' },
    30900: { lat: 5.45283, long: -55.187801, code: 'PBM' },
    31000: { lat: 6.49855, long: -58.254101, code: 'GEO' },
    31100: { lat: 13.0746, long: -59.4925, code: 'BGI' },
    31200: { lat: 12.0042, long: -61.786201, code: 'GND' },
    31300: { lat: 12.1889, long: -68.959801, code: 'CUR' },
    31400: { lat: 18.42970085144, long: -69.668899536133, code: 'SDQ' },
    31500: { lat: 19.406099319458008, long: -70.60469818115234, code: 'STI' },
    31600: { lat: 17.935699462890625, long: -76.7874984741211, code: 'KIN' },
    31700: { lat: 25.79319953918457, long: -80.29060363769531, code: 'MIA' },
    31800: { lat: 27.975500106811523, long: -82.533203125, code: 'TPA' },
    31900: { lat: 29.6900997162, long: -82.2717971802, code: 'GNV' },
    32000: { lat: 30.4941006, long: -81.6878967, code: 'JAX' },
    32100: { lat: 30.3965, long: -84.350304, code: 'TLH' },
    32200: { lat: 32.300598, long: -86.393997, code: 'MGM' },
    32300: { lat: 33.6367, long: -84.428101, code: 'ATL' },
    32400: { lat: 33.8755989075, long: -84.3020019531, code: 'PDK' },
    32500: { lat: 36.1245002746582, long: -86.6781997680664, code: 'BNA' },
    32600: { lat: 35.04240036010742, long: -89.97669982910156, code: 'MEM' },
    32700: { lat: 38.748697, long: -90.370003, code: 'STL' },
    32800: { lat: 39.7173, long: -86.294403, code: 'IND' },
    32900: { lat: 41.9786, long: -87.9048, code: 'CHI' },
    33000: { lat: 41.9786, long: -87.9048, code: 'ORD' },
    33100: { lat: 42.212398529052734, long: -83.35340118408203, code: 'DTW' },
    33200: { lat: 41.411701, long: -81.8498, code: 'CLE' },
    33300: { lat: 40.49150085, long: -80.23290253, code: 'PIT' },
    33400: { lat: 39.998001, long: -82.891899, code: 'CMH' },
    33500: { lat: 39.813801, long: -82.927803, code: 'LCK' },
    33600: { lat: 35.2140007019043, long: -80.94309997558594, code: 'CLT' },
    33700: { lat: 35.877602, long: -78.787498, code: 'RDU' },
    33800: { lat: 36.8946, long: -76.201202, code: 'ORF' },
    33900: { lat: 37.50519943237305, long: -77.3197021484375, code: 'RIC' },
    34000: { lat: 38.9445, long: -77.455803, code: 'IAD' },
    34100: { lat: 38.8521, long: -77.037697, code: 'DCA' },
    34200: { lat: 39.87189865112305, long: -75.24109649658203, code: 'PHL' },
    34300: { lat: 40.639447, long: -73.779317, code: 'NYC' },
};

